import * as React from "react"
import { cn } from "../../lib/utils"

export interface SwitchProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked: boolean
  onCheckedChange?: (checked: boolean) => void
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, onCheckedChange, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? "on" : "off"}
      onClick={(event) => {
        props.onClick?.(event)
        if (!event.defaultPrevented) {
          onCheckedChange?.(!checked)
        }
      }}
      className={cn(
        "relative inline-flex h-6 w-11 cursor-pointer items-center rounded-pill border border-border-subtle bg-background-muted transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background data-[state=on]:border-brand data-[state=on]:bg-brand",
        className,
      )}
      {...props}
    >
      <span
        aria-hidden="true"
        data-state={checked ? "on" : "off"}
        className="inline-block h-4 w-4 translate-x-1 rounded-full bg-foreground shadow-outline transition-transform data-[state=on]:translate-x-6 data-[state=on]:bg-background"
      />
    </button>
  ),
)
Switch.displayName = "Switch"
